export const labels = [
    "Dolor o molestia en el cuero cabelludo en el sitio de estimulación",
    "Dolor de cabeza leve",
    "Somnolencia o fatiga posterior a la sesión",
    "Molestia facial (espasmos musculares o sensaciones incómodas)",
    "Zumbido en los oídos (acúfenos)",
    "Náuseas",
    "Ansiedad o inquietud durante o después de la sesión",
    "Empeoramiento temporal del estado de ánimo",
    "Mareos o sensación de inestabilidad",
    "Cambios en el sueño (dificultad para dormir o sueño excesivo)",
    "Empeoramiento de síntomas psiquiátricos preexistentes",
    "Convulsiones (extremadamente raras)",
]